import React, { useState, useEffect } from "react";
import { Header } from "../../../components/user-dashboard/header";
import { Sidebar } from "../../../components/user-dashboard/sidebar";
import { DataTable } from "../../../components/tables";
import { cgpaDataGridCols } from "./CgpaDataGridCols";
import { useNavigate } from "react-router-dom";
import { AdminService } from "../../../app/service/admin.service";
import { toast } from "react-toastify";
import moment from "moment";

const CgpaList = () => {
  const [name, setName] = useState("");
  const [CgpaData, setCgpaData] = useState([]);
  const navigate = useNavigate();
  const [date, setDate] = useState("");
  const [filteredStudents, setFilteredStudents] = useState([]);

  const handleCancel = () => {
    setName("");
    setDate("");
    setFilteredStudents(CgpaData);
  };
  const handleSearch = () => {
    const filteredData = CgpaData.filter((student: any) => {
      const emailMatch = student.emailAddress
        ?.toLowerCase()
        .includes(name.toLowerCase());

      const dateMatch = date
        ? moment(student.createdAt).format("YYYY-MM-DD") === date
        : true;

      return emailMatch && dateMatch;
    });

    setFilteredStudents(filteredData);
  };

  useEffect(() => {
    getCgpas();
  }, []);

  const getCgpas = () => {
    const data = {
      search: "",
      start: 1,
      count: 10,
    };
    AdminService.getAllCgpaList(data).then((res: any) => {
      if (res.status === "Success") {
        const formattedData = res?.data.map((item: any) => ({
          ...item,
          createdAt: moment(item.createdAt).format("DD MMM YYYY, hh:mm A"),
        }));
        setCgpaData(formattedData);
        setFilteredStudents(formattedData);
      } else {
        toast.error(res.message);
      }
    });
  };

  const deleteCgpa = (cgpaId: any) => {
    const payload = {
      cgpaId: cgpaId?._id,
    };
    AdminService.deleteCgpa(payload).then((res: any) => {
      if (res.status === "Success") {
        toast.success(res.message);
        getCgpas();
      } else {
        toast.error(res.message);
      }
    });
  };
  const handleEditMeet = (data: any) => {
    navigate("/support/editMeet", { state: data });
  };

  const handleCgpaAccess = (data: any) => {
    navigate("/support/cgpaAccess", { state: data });
  };

  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <Header />
        </div>
        <div className="row">
          <div className="col-md-2 h-100 px-0">
            <Sidebar />
          </div>
          <div className="col-md-10 content-scroll content-bg px-3 py-3">
            <div className="row">
              <div className="col-md-8 mt-3">
                <label className="form-label d-flex justify-content-start text-start">
                  <b>CGPA List</b>
                </label>
                <div className="d-flex">
                  <input
                    name="User Name"
                    onChange={(e: any) => setName(e.target.value)}
                    className="form-control mt-1 me-2"
                    value={name}
                    placeholder="Enter the Email"
                  />
                  <input
                    type="date"
                    name="Date"
                    onChange={(e: any) => setDate(e.target.value)}
                    className="form-control mt-1 me-2"
                    value={date}
                  />
                  <button
                    className="btn btn-primary rounded px-4 py-1"
                    onClick={() => handleSearch()}
                  >
                    Search
                  </button>
                  <button
                    className="btn btn-secondary rounded ms-2 px-4 py-1"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
              {/* <div className="col-md-6 mt-3">
                <div className="text-end">
                  <button
                    className="btn btn-success"
                    onClick={handleCreateMeet}
                  >
                    Create Project
                  </button>
                </div>
              </div> */}
            </div>
            <div className="mt-5">
              <DataTable
                tableData={filteredStudents}
                TableCols={cgpaDataGridCols}
                deleteCgpa={deleteCgpa}
                handleEditMeet={handleEditMeet}
                handleCgpaAccess={handleCgpaAccess}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CgpaList;
